module.exports = __webpack_public_path__ + "static/media/ic-arrow-drop-down-grey.ae9ca0da.svg";